module.exports = __webpack_public_path__ + "img/logo3.284de2ae.png";